/*
 * The kernel of the contexts: roles, permissions and members. Its roles and permissions are a tab
 * of the admin settings, the members one of a record's settings, a user's memberships a section of
 * the admin user dialog. The front-end manifest, see lib/docs/extensions/writing-an-extension.md.
 */
import { defineExtension } from '@lib/extensions/define';
import { useAppContextStore } from '@lib/plugins/layouts/context';

import de from './locale/de';
import en from './locale/en';

export default defineExtension({
	name: 'context',
	locale: { de, en },
	slots: {
		'admin.settings': [
			{
				id: 'context_roles_and_permissions',
				icon: 'fa-users-gear',
				group: 'access',
				after: 'roles_and_permissions',
				permission: 'app.settings',
				component: () => import('./pages/ContextRolesAndPermissions.vue'),
			},
		],
		// What a user is a member of, in the admin user dialog
		'user.edit': [
			{
				id: 'memberships',
				permission: 'users.read',
				component: () => import('./components/UserMemberships.vue'),
			},
		],
		'context.settings': [
			{
				id: 'members',
				icon: 'fa-users',
				group: 'members',
				label: 'tabs.context_settings.members',
				// Only a context with members to manage, see ContextDefinition::hasUsers()
				when: ({ context }) => useAppContextStore().getContexts.some((entry) => entry.context === context && entry.has_users),
				// Seeing the members takes users.read on the record or app wide; changing them users.write
				contextPermission: 'users.read',
				component: () => import('./components/ContextMembersTab.vue'),
			},
		],
	},
});
